import React, { SetStateAction, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import History from "./History";

interface INavbar {
  value: string;
  arr: string[];
  setArr: React.Dispatch<SetStateAction<string[]>>;
}

const Navbar = ({ value, arr, setArr }: INavbar) => {
  const [historyShow, setHistoryShow] = useState<boolean>(true);

  const handleHistoryShow = () => {
    setHistoryShow((prev) => !prev);
  };

  return (
    <nav className="navbar-wrapper">
      <div className="left-container">
        <div className="hamburger-container">
          <GiHamburgerMenu onClick={handleHistoryShow} className="hamburger" />
          <p className="standard">Standard</p>
        </div>
        {historyShow && (
          <div className="right-container">
            <div className="history-wrapper">
              <p className="history">History</p>
            </div>
            <div className="memory-wrapper">
              <p className="memory">Memory</p>
            </div>
          </div>
        )}
      </div>
      {historyShow && <History arr={arr} setArr={setArr} />}
      {historyShow && (
        <div className="display-history-div">
          <p className="history-number">{value}</p>
          {value === "0" && (
            <p className="no-history">There's no history yet</p>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
